import dayjs from "dayjs";

export function formatDriversTurnOverResponse(driversTurnOver) {
  const newArray = [];

  driversTurnOver.forEach((obj, index) => {
    const {
      billId,
      tableName,
      created,
      moved,
      executed,
      closed,
      accepted,
      expected,
      geocoding,
    } = obj;

    const checkedCreated =
      accepted !== "0001-01-01T00:00:00"
        ? dayjs(created, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
            dayjs(accepted, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
            "minutes"
          )
        : dayjs(created).format("DD.MM - HH:mm:ss");

    const checkedMoved =
      moved !== "0001-01-01T00:00:00"
        ? dayjs(moved, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
            dayjs(executed, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
            "minutes"
          )
        : "-";

    const checkedClosed =
      checkedMoved === "-"
        ? dayjs(closed, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
            dayjs(executed, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
            "minutes"
          )
        : dayjs(closed, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
            dayjs(moved, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
            "minutes"
          );

    const acceptedOrder =
      accepted !== "0001-01-01T00:00:00"
        ? dayjs(accepted).format("DD.MM - HH:mm:ss")
        : "-";

    const checkedExpected =
      expected !== "0001-01-01T00:00:00"
        ? dayjs(closed, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
            dayjs(expected, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
            "minutes"
          )
        : "-";

    const checkedTotalTime =
      accepted !== "0001-01-01T00:00:00"
        ? dayjs(closed, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
            dayjs(accepted, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
            "minutes"
          )
        : dayjs(closed, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
            dayjs(created, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
            "minutes"
          );

    const distanceBetweenLocationsInMeters =
      geocoding?.distanceBetweenLocationsInMeters === undefined
        ? "-"
        : geocoding.distanceBetweenLocationsInMeters;

    newArray.push({
      key: index,
      tableNumber: tableName,
      billId: billId,
      created: checkedCreated,
      executed: dayjs(executed, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }).diff(
        dayjs(created, { format: "YYYY-MM-DDTHH:mm:ss.SSS" }),
        "minutes"
      ),
      moved: checkedMoved,
      closed: checkedClosed,
      totalTime: checkedTotalTime,
      accepted: acceptedOrder,
      result: checkedExpected,
      distanceBetweenLocationsInMeters: distanceBetweenLocationsInMeters,
    });
  });
  return newArray;
}
